import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { AppointmentsEmojiIcon } from "../../../../atoms/icons/AppointmentsEmojiIcon";
import { ClassesEmojiIcon } from "../../../../atoms/icons/ClassesEmojiIcon";
import { VisitsEmojiIcon } from "../../../../atoms/icons/VisitsEmojiIcon";

export const AttendanceWidget = ({
  type,
}: {
  type: "gymAttendance" | "classAttendance" | "appointmentAttendance";
}) => {
  const { t } = useTranslation();
  const widgetLabels = {
    gymAttendance: t("page.settings.appSettings.homePagePreview.gymAttendance"),
    classAttendance: t(
      "page.settings.appSettings.homePagePreview.classAttendance",
    ),
    appointmentAttendance: t(
      "page.settings.appSettings.homePagePreview.appointmentAttendance",
    ),
  } as const;
  const icons = {
    gymAttendance: <VisitsEmojiIcon className="size-5" />,
    classAttendance: <ClassesEmojiIcon className="size-5" />,
    appointmentAttendance: <AppointmentsEmojiIcon className="size-5" />,
  };
  const counts = {
    gymAttendance: 27,
    classAttendance: 15,
    appointmentAttendance: 4,
  };

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="flex w-full flex-row items-center justify-between gap-2 rounded-2xl border border-gray-200 bg-white p-3"
    >
      <div className="flex flex-row items-center gap-3">
        <div className="text-2xl text-gray-950">{icons[type]}</div>
        <div className="text-sm font-medium text-gray-500">
          {widgetLabels[type]}
        </div>
      </div>

      <div className="text-xl font-bold text-gray-950">{counts[type]}</div>
    </motion.div>
  );
};
